import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/line-chart/pages/CalculatorPage";

export const Route = createFileRoute("/line-chart")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/line-chart",
      title: m.line_meta_title(),
      description: m.line_meta_description(),
      toolName: m.line_tool_name(),
      faqs: [
        { q: m.line_faq_q1(), a: m.line_faq_a1() },
        { q: m.line_faq_q2(), a: m.line_faq_a2() },
        { q: m.line_faq_q3(), a: m.line_faq_a3() },
        { q: m.line_faq_q4(), a: m.line_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
